import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addnewaction',
  templateUrl: './addnewaction.component.html',
  styleUrls: ['./addnewaction.component.css']
})
export class AddnewactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
